<template>
  <section class="border border-gray-200 rounded-lg bg-white h-[400px] flex flex-col">
    <div class="px-5 py-4 border-b border-gray-200">
      <h2 class="text-base font-semibold text-gray-900">Latency trend</h2>
      <p class="text-xs text-gray-600 mt-0.5">P90 and P95 browser-observed request duration.</p>
    </div>
    <div v-if="loading" class="flex-1 flex items-center justify-center">
      <LoadingIndicator message="Loading latency trend..." />
    </div>
    <div v-else-if="error" class="flex-1 overflow-auto p-5 text-sm text-red-dark">
      {{ error }}
    </div>
    <div v-else-if="!rows.length" class="flex-1 p-5 text-sm text-gray-600">
      No request latency was recorded for this period.
    </div>
    <div v-else class="flex-1 min-h-0 px-4 pb-3">
      <Chart_V5
        :chart_data="chartData"
        :chart_config="chartConfig"
        :show-export="false"
        override-height="h-full"
      />
    </div>
  </section>
</template>

<script>
import Chart_V5 from '@/components/widgetcomponents/Viz_Elements/Chart_V5.vue';
import LoadingIndicator from '@/components/widgetcomponents/library/LoadingIndicator.vue';
import { formatDuration } from './latency_format';

export default {
  name: 'LatencyTrend',
  components: { Chart_V5, LoadingIndicator },
  props: {
    rows: { type: Array, required: true },
    rangeDays: { type: Number, required: true },
    loading: { type: Boolean, default: false },
    error: { type: String, default: null },
  },
  computed: {
    chartData() {
      return {
        labels: this.rows.map((row) => this.bucketLabel(row.bucket)),
        series: [
          {
            values: this.rows.map((row) => row.p90_ms),
            config: {
              label: 'P90', backgroundColor: '#4573D2', type: 'line', yAxis: 'left', offset: 0,
            },
          },
          {
            values: this.rows.map((row) => row.p95_ms),
            config: {
              label: 'P95', backgroundColor: '#F76734', type: 'line', yAxis: 'left', offset: 0,
            },
          },
        ],
      };
    },
    chartConfig() {
      return {
        chartType: 'vertical_bar',
        margin: { top: 35, right: 25, bottom: this.rangeDays === 30 ? 65 : 50, left: 65 },
        xAxis: { labelRotation: this.rangeDays === 30 ? -45 : 0, fontSize: 10 },
        yAxes: [{
          position: 'left', min: 0, fontSize: 10,
          title: 'Browser-observed duration', tickFormat: formatDuration,
        }],
        legend: { display: true, position: 'top', spacing: 10 },
        labelDisplayConfig: { hideDataLabels: true, minLabelSpacing: 5 },
        formatting: { percentage: false, sig_figs: 0 },
      };
    },
  },
  methods: {
    bucketLabel(value) {
      if (this.rangeDays === 1) {
        return new Date(value).toLocaleTimeString(undefined, { hour: 'numeric' });
      }
      return new Date(`${value.slice(0, 10)}T00:00:00Z`).toLocaleDateString(undefined, {
        month: 'short', day: 'numeric', timeZone: 'UTC',
      });
    },
  },
};
</script>
